// Authenticated user roles. Source of truth is Entra ID group membership
// (PRD §8); the `users` table caches the mapping per the Q4 schema-plan
// decision. Capture UI and admin routes branch on these values.

import { userRoleEnum } from '../db/schema'

export const USER_ROLE = {
  FIELD_STAFF: 'field_staff',
  ADMIN: 'admin',
} as const satisfies Record<string, 'field_staff' | 'admin'>

export type UserRole = 'field_staff' | 'admin'

export const USER_ROLE_VALUES = userRoleEnum.enumValues
